import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { E3Logo } from "@/components/brand/E3Logo";

export const Footer = () => {
    return (
        <footer data-testid="e3-footer" className="bg-stone-950 text-stone-300 mt-24">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
                    <div className="md:col-span-5">
                        <div className="bg-white/95 rounded-2xl p-4 inline-block mb-6">
                            <E3Logo showTagline />
                        </div>
                        <p className="text-stone-400 max-w-md leading-relaxed">
                            Building India's next-generation high-speed EV charging network.
                            500+ fast charging stations planned, powered by Cubenz Technology™.
                        </p>
                        <div className="mt-8 flex flex-col gap-3 text-sm">
                            <a href="mailto:info@e3charge.network" className="flex items-center gap-3 text-stone-400 hover:text-white">
                                <Mail className="w-4 h-4" /> info@e3charge.network
                            </a>
                            <a href="tel:+910000000000" className="flex items-center gap-3 text-stone-400 hover:text-white">
                                <Phone className="w-4 h-4" /> +91 · Coming Soon
                            </a>
                            <div className="flex items-start gap-3 text-stone-400">
                                <MapPin className="w-4 h-4 mt-0.5" />
                                <span>E3 Team HQ · Gujarat · India<br />
                                <span className="text-stone-500">Full address coming soon</span></span>
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <div className="e3-overline mb-5 text-stone-400">Network</div>
                        <ul className="space-y-3 text-sm">
                            <li><Link to="/" className="hover:text-white">Home</Link></li>
                            <li><Link to="/about" className="hover:text-white">About</Link></li>
                            <li><Link to="/usp" className="hover:text-white">Why E3</Link></li>
                            <li><Link to="/technology" className="hover:text-white">Technology</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <div className="e3-overline mb-5 text-stone-400">Partners</div>
                        <ul className="space-y-3 text-sm">
                            <li><Link to="/investor" className="hover:text-white">Investors</Link></li>
                            <li><Link to="/franchise" className="hover:text-white">Franchise</Link></li>
                            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="e3-overline mb-5 text-stone-400">Join the Network</div>
                        <p className="text-sm text-stone-400 mb-5">
                            Own the infrastructure. Build recurring income.
                        </p>
                        <Link to="/contact" data-testid="footer-cta-partner" className="e3-btn-primary text-sm">
                            Become a Partner <ArrowUpRight className="w-4 h-4" />
                        </Link>
                    </div>
                </div>

                <div className="pt-8 border-t border-stone-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-stone-500">
                    <div>© {new Date().getFullYear()} E3 Charge Network · Earth Energy Engine. All rights reserved.</div>
                    <div>Powered by Cubenz Technology™ · EV Charging Infrastructure OEM</div>
                </div>
            </div>
        </footer>
    );
};
